const MessageValues = {
  erro_catch: 'Ocorreu um erro no processamento da requisição. Contate o suporte.',

};

export {MessageValues};
